var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropDownArrow = function SvgDropDownArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M10.327.286 6 4.622 1.673.286A.98.98 0 0 0 .978 0a.98.98 0 0 0-.693.286.99.99 0 0 0 0 1.39l5.02 5.03a.98.98 0 0 0 1.388 0l5.02-5.03a.985.985 0 0 0 0-1.39A.97.97 0 0 0 11.02 0a.98.98 0 0 0-.693.286"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropDownArrow);
export default ForwardRef;